<script setup lang="ts">
import { toRefs } from 'vue';
import type { DataTableCellProps } from '@common';
import type { SoilTemperatureParcelData } from '../../models';

const props = defineProps<DataTableCellProps<any, SoilTemperatureParcelData>>();
const { item } = toRefs(props);
</script>

<template>
  <v-chip
    v-if="item.data.classification"
    data-testid="soil-temperature-classification-chip"
    :color="item.data.classificationColor">
    {{ item.data.classification }}
  </v-chip>

  <span v-else>-</span>
</template>
